export default __webpack_public_path__ + "241fcf9b22157c10c4678f1db4a60997.svg";